import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feefrequency.css";

export default function MH20ER4534() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Fuel Details</h4>
        <div className="yc-header-actions">
          <Link to="/accountant/updatevehiclemaintenance" className="btn btn-primary">
            Edit
          </Link>
          <button type="button" className="btn btn-danger">Delete</button>
        </div>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Bus Code</td>
                    <td>MH20ER4534</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Maintenance Task</td>
                    <td>Servicing</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Schedule Duration (H)</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Start Date</td>
                    <td>Sat May 10 2025</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Next Due Date / Mileage</td>
                    <td>Mon May 12 2025</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Type of Task</td>
                    <td>Instant</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Off-Road</td>
                    <td>Enabled</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
